import React, { useState, useEffect } from "react";

export default function Categories({ onSelect }) {
  const [categories, setCategories] = useState([]);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    axios
      .get(constvar.api_url + "home/job_filter_data")
      .then((res) => {
        if (res.data.status === "success") {
          setCategories(res.data.jobtype || []);
        }
      })
      .catch(() => {});
  }, []);

  if (categories.length === 0) return null;

  const handleClick = (cat) => {
    const next = activeId === cat.id ? null : cat.id;
    setActiveId(next);
    if (onSelect) onSelect(next || 0);
  };

  return (
    <div className="sf-categories-bar">
      <div className="sf-container">
        <div className="sf-categories-list">
          <span className="sf-categories-label">Popular Searches</span>
          {categories.map((cat) => (
            <span
              key={cat.id}
              className={"sf-category-tag" + (activeId === cat.id ? " active" : "")}
              onClick={() => handleClick(cat)}
            >
              {cat.title}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
